// ===========================================================================
// Provider Performance & Scorecards (Module M) — fake data determinístico.
//
// Backend futuro (según docs/modulos/BillingV2/MODULO_M_PROVIDER_PERFORMANCE.md):
//   GET /api/analytics/provider-scorecards?period=YYYY-MM
//       → analytics.TAB_PROVIDER_SCORECARD por NUM_ID_EMPLOYEE_PCP
//   GET /api/analytics/provider-scorecards/{providerId}
//       → scorecard individual + peer comparison
//
// 12 providers de muestra (nombres estilo roster real, NPIs ficticios).
// Valores fijos para que la demo sea estable.
// ===========================================================================

/**
 * Scorecards de PCPs.
 * - rafScore: Risk Adjustment Factor promedio del panel
 * - codingSpecificity: % de diagnósticos al máximo nivel de especificidad (Módulo F)
 * - chargeLagDays: días promedio entre servicio y posteo del charge (Módulo N)
 * - gapClosureRate: % de care gaps cerrados YTD
 * - hccRecaptureRate: % de HCCs del año previo recapturados (Módulo E)
 * - awvCompletion: % del panel con Annual Wellness Visit al día
 * - postDischargeFollowUp: % de altas con follow-up en 7 días
 * - visitsPerDay: visitas promedio por día clínico
 */
export const FAKE_PROVIDERS = [
  {
    id: "1093494411",
    name: "RIVERA GARCIA, JOYCE ARNP",
    center: "Lake Worth",
    panelSize: 768,
    rafScore: 1.12,
    codingSpecificity: 71.4,
    chargeLagDays: 5.8,
    gapClosureRate: 58.2,
    hccRecaptureRate: 66.0,
    awvCompletion: 52.1,
    postDischargeFollowUp: 61.5,
    visitsPerDay: 18.4,
  },
  {
    id: "1447212295",
    name: "PENA SANCHEZ, ORLY MD",
    center: "Lake Worth",
    panelSize: 734,
    rafScore: 1.31,
    codingSpecificity: 84.6,
    chargeLagDays: 2.9,
    gapClosureRate: 71.3,
    hccRecaptureRate: 78.9,
    awvCompletion: 64.8,
    postDischargeFollowUp: 73.2,
    visitsPerDay: 16.9,
  },
  {
    id: "1689637589",
    name: "JEAN BAPTISTE, JEAN E MD",
    center: "Lake Worth",
    panelSize: 509,
    rafScore: 1.05,
    codingSpecificity: 66.2,
    chargeLagDays: 7.4,
    gapClosureRate: 49.7,
    hccRecaptureRate: 58.3,
    awvCompletion: 47.9,
    postDischargeFollowUp: 54.0,
    visitsPerDay: 13.2,
  },
  {
    id: "1891127494",
    name: "GASPARD, RICARDO EMMANUEL MD",
    center: "Immokalee",
    panelSize: 672,
    rafScore: 1.44,
    codingSpecificity: 88.1,
    chargeLagDays: 2.1,
    gapClosureRate: 76.8,
    hccRecaptureRate: 82.4,
    awvCompletion: 69.5,
    postDischargeFollowUp: 79.1,
    visitsPerDay: 19.6,
  },
  {
    id: "1508093154",
    name: "SMITH, REYNALDO PEZZOTTI MD",
    center: "Immokalee",
    panelSize: 414,
    rafScore: 1.18,
    codingSpecificity: 74.9,
    chargeLagDays: 4.6,
    gapClosureRate: 62.5,
    hccRecaptureRate: 69.7,
    awvCompletion: 57.3,
    postDischargeFollowUp: 65.8,
    visitsPerDay: 14.7,
  },
  {
    id: "1538737184",
    name: "MOLINA-CHUY, YANELA APRN",
    center: "Immokalee",
    panelSize: 287,
    rafScore: 0.97,
    codingSpecificity: 79.3,
    chargeLagDays: 3.4,
    gapClosureRate: 67.9,
    hccRecaptureRate: 71.2,
    awvCompletion: 61.0,
    postDischargeFollowUp: 68.4,
    visitsPerDay: 12.5,
  },
  {
    id: "1730481126",
    name: "ORTEGA SUAREZ, MARIA L MD",
    center: "Fort Myers",
    panelSize: 651,
    rafScore: 1.27,
    codingSpecificity: 81.7,
    chargeLagDays: 3.0,
    gapClosureRate: 69.4,
    hccRecaptureRate: 75.6,
    awvCompletion: 62.9,
    postDischargeFollowUp: 70.6,
    visitsPerDay: 17.8,
  },
  {
    id: "1962584470",
    name: "DESROSIERS, KETTYNA APRN",
    center: "Fort Myers",
    panelSize: 458,
    rafScore: 1.02,
    codingSpecificity: 63.8,
    chargeLagDays: 8.9,
    gapClosureRate: 44.1,
    hccRecaptureRate: 55.2,
    awvCompletion: 41.6,
    postDischargeFollowUp: 49.3,
    visitsPerDay: 11.4,
  },
  {
    id: "1275539018",
    name: "FERNANDEZ COLLAZO, CARLOS J MD",
    center: "Hialeah",
    panelSize: 802,
    rafScore: 1.39,
    codingSpecificity: 86.2,
    chargeLagDays: 2.4,
    gapClosureRate: 73.5,
    hccRecaptureRate: 80.1,
    awvCompletion: 67.2,
    postDischargeFollowUp: 75.9,
    visitsPerDay: 20.8,
  },
  {
    id: "1417026452",
    name: "VALDES PEREZ, RAUL MD",
    center: "Hialeah",
    panelSize: 697,
    rafScore: 1.21,
    codingSpecificity: 76.5,
    chargeLagDays: 5.1,
    gapClosureRate: 60.8,
    hccRecaptureRate: 68.3,
    awvCompletion: 55.4,
    postDischargeFollowUp: 63.7,
    visitsPerDay: 16.1,
  },
  {
    id: "1649372880",
    name: "CASTILLO MENDOZA, ANA APRN",
    center: "Lehigh Acres",
    panelSize: 521,
    rafScore: 1.09,
    codingSpecificity: 69.8,
    chargeLagDays: 6.3,
    gapClosureRate: 53.6,
    hccRecaptureRate: 61.9,
    awvCompletion: 50.2,
    postDischargeFollowUp: 57.5,
    visitsPerDay: 13.9,
  },
  {
    id: "1851304267",
    name: "PIERRE-LOUIS, MICHELINE MD",
    center: "Port St. Lucie",
    panelSize: 588,
    rafScore: 1.16,
    codingSpecificity: 72.6,
    chargeLagDays: 4.2,
    gapClosureRate: 64.7,
    hccRecaptureRate: 70.5,
    awvCompletion: 58.8,
    postDischargeFollowUp: 66.2,
    visitsPerDay: 15.3,
  },
];
